import { render, staticRenderFns } from "./GrouponSettings.vue?vue&type=template&id=2c96c37b&scoped=true"
import script from "./GrouponSettings.vue?vue&type=script&lang=js"
export * from "./GrouponSettings.vue?vue&type=script&lang=js"
import style0 from "./GrouponSettings.vue?vue&type=style&index=0&id=2c96c37b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c96c37b",
  null
  
)

export default component.exports